// This is just for the Loading or Error Selector
export const GET_OVERTAKES = 'GET_OVERTAKES';

// Use these for Actions
export const GET_OVERTAKES_REQUEST = 'GET_OVERTAKES_REQUEST';
export const GET_OVERTAKES_SUCCESS = 'GET_OVERTAKES_SUCCESS';
export const GET_OVERTAKES_ERROR = 'GET_OVERTAKES_ERROR';

